import { useRef, useState } from "react";
import { toast } from "sonner";
import { Camera } from "lucide-react";
import { api, errMsg, photoUrl, initials, FLAG } from "@/lib/api";

export const ClientTile = ({ client, onOpen, onPhotoChanged }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const url = photoUrl(client.id, client.photoKey);
  const flagCls = FLAG[client.flag ?? "on_track"]?.[0] ?? "ok";

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try { await api.post(`/clients/${client.id}/photo`, fd); toast.success(`Photo updated for ${client.name.split(" ")[0]}`); onPhotoChanged(); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };

  return (
    <div className={`tile ${client.active ? "" : "inactive"}`} onClick={() => onOpen(client)} data-testid={`client-tile-${client.id}`}>
      {url ? <img src={url} alt={client.name} /> : <div className="tile-ini">{initials(client.name)}</div>}
      <div className="tile-shade" />
      <span className={`tile-dot ${flagCls}`} title={FLAG[client.flag]?.[1]} data-testid={`tile-flag-${client.id}`}><span className="dot" /></span>
      <button type="button" className="tile-cam" disabled={busy} onClick={(e) => { e.stopPropagation(); input.current?.click(); }} title="Upload photo" data-testid={`tile-upload-${client.id}`}>
        {busy ? <span className="spin" style={{ borderTopColor: "#fff" }} /> : <Camera size={15} />}
      </button>
      <input ref={input} type="file" accept="image/*" hidden onChange={upload} onClick={(e) => e.stopPropagation()} data-testid={`tile-file-input-${client.id}`} />
      <div className="tile-name"><b>{client.name}</b><small>{client.goal || "—"} · {client.sessionsPerWeek}x/wk</small></div>
    </div>
  );
};
